import {
  Button as ButtonV2,
  Color,
  Flex,
  Icon,
  Text,
  Title,
} from '@brokerbay/elements-web';
import { Button, Modal, message } from 'components';
import { AuthContext } from 'contexts';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { formatPhoneNumber } from 'utils';
import deleteNonAgent from '../../../../../../api/NonAgentController/delete';
import { appointmentTypeToNonAgentLabel } from '../../constants';
import CoopSelectContext from '../CoopSelectContext';
import Notes from './Notes';

const NonAgentDetails: React.FC = () => {
  const { auth } = useContext(AuthContext);
  const { setBookFor, coop, setCoop, coopAdditionalData } =
    useContext(CoopSelectContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  if (
    !coop ||
    !coopAdditionalData ||
    coopAdditionalData.coopType !== 'nonAgent'
  )
    return null;

  const showEditButtons = coopAdditionalData.createdBy === auth.id;
  const nonAgentLabel =
    appointmentTypeToNonAgentLabel[coopAdditionalData.nonAgentType];

  const handleDelete = async () => {
    await deleteNonAgent(coop.id!);
    message.success('Custom contact deleted');
    setIsModalOpen(false);
    setCoop(null);
  };

  return (
    <StyledFlex vertical gap="small">
      <div>
        <Text thickness="bold">Name: </Text>
        <Text>
          {coop.firstName!.toUpperCase()} {coop.lastName!.toUpperCase()}
        </Text>
      </div>
      <div>
        <Text size="large">{coopAdditionalData.orgName.toUpperCase()}</Text>
        {coopAdditionalData.orgAddress && (
          <>
            <br />
            <Text>{coopAdditionalData.orgAddress.toUpperCase()}</Text>
          </>
        )}
      </div>
      <div>
        <Text thickness="bold">Office: </Text>
        <Text>{formatPhoneNumber(coopAdditionalData.orgPhone)}</Text>
        <br />
        <Text thickness="bold">Mobile: </Text>
        <Text>{formatPhoneNumber(coop.phone)}</Text>
        <br />
        <Text thickness="bold">Email: </Text>
        <Text>{coop.email}</Text>
      </div>
      <DangerText thickness="bold">This person is NOT an agent</DangerText>
      {!coopAdditionalData.customContactPreApproved && (
        <Text>Listing agent to confirm approval for this contact</Text>
      )}
      <Notes />
      {showEditButtons && (
        <Flex justify="space-around">
          <Button
            size="small"
            type="primary"
            data-cy="editNonAgent-btn"
            onClick={() => setBookFor('nonAgentCreate')}
          >
            Edit Profile
          </Button>
          <Button
            size="small"
            type="primary"
            danger
            data-cy="deleteNonAgent-btn"
            onClick={() => setIsModalOpen(true)}
          >
            Delete Profile
          </Button>
        </Flex>
      )}
      <Modal
        title={
          <Flex gap="middle" align="center">
            <Icon icon="warningOutlined" size={24} color="warning" />
            <Title level={3} dataCy="recordShowingModal-title">
              Delete {nonAgentLabel}
            </Title>
          </Flex>
        }
        footer={
          <Flex justify="space-around">
            <ButtonV2
              dataCy="cancelNonAgentDelete-btn"
              type="secondary"
              onClick={() => setIsModalOpen(false)}
            >
              Cancel
            </ButtonV2>{' '}
            <StyledDeleteButton
              dataCy="yesNonAgentDelete-btn"
              onClick={handleDelete}
            >
              Yes
            </StyledDeleteButton>
          </Flex>
        }
        centered
        closable={false}
        open={isModalOpen}
        data-cy="nonAgent-delete-modal"
      >
        <Text style={{ textAlign: 'center' }} size="large">
          Are you sure you want to delete this {nonAgentLabel}? This operation
          is permanent and cannot be undone.
        </Text>
      </Modal>
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  padding: 15px 0;
`;

const StyledDeleteButton = styled(ButtonV2)`
  background: ${Color.JANEMBA};
`;

export const DangerText = styled(Text)`
  color: ${Color.JANEMBA};
`;

export default NonAgentDetails;
